import { createAction, props } from '@ngrx/store';

/**
 * Actions für den Change-Credentials-Dialog.
 */
export class ChangeCredentialsDialogActions {
  private static readonly prefix = '[Dialog Change Credentials]';

  /**
   * Öffnet den Dialog mit den übergebenen Daten.
   */
  public static open = createAction(
    `${this.prefix} Open dialog`,
    props<{ title: string; prompt: string; url: string }>(),
  );

  /**
   * Schließt den Dialog.
   */
  public static close = createAction(
    `${this.prefix} Close dialog`,
  );
}
